
      var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMute = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#mute_ca9fd592520d274d__b)",
  clipPath: "url(#mute_ca9fd592520d274d__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.165 14.86V4.916c0-1.128-1.312-1.746-2.182-1.028L14 8m-6.667 2.296H6.012c-.737 0-1.334.597-1.334 1.333v8.046c0 .737.597 1.334 1.334 1.334h4.708c.32 0 .63.115.873.326l7.365 6.386c.864.749 2.207.136 2.207-1.007v-2.302m3.757-.62L6.209 4.8",
  stroke: "#E1E1E1",
  strokeWidth: 2.5,
  strokeLinecap: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "mute_ca9fd592520d274d__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v32H0z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "mute_ca9fd592520d274d__b",
  x: 1.246,
  y: 0.873,
  width: 27.107,
  height: 31.338,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.727
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.091
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_22941_19588"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_22941_19588",
  result: "shape"
})))));

      const __svgRaw = "<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<g clip-path=\"url(#clip0_22941_19588)\">\r\n<g filter=\"url(#filter0_d_22941_19588)\">\r\n<path d=\"M21.1652 14.8604V4.91592C21.1652 3.78846 19.8528 3.16993 18.9832 3.88753L13.9998 7.99992M7.33317 10.2956H6.01156C5.27518 10.2956 4.67822 10.8926 4.67822 11.6289V19.6753C4.67822 20.4117 5.27518 21.0087 6.01156 21.0087H10.7198C11.0407 21.0087 11.3508 21.1244 11.5933 21.3346L18.9583 27.7211C19.8217 28.4698 21.1652 27.8565 21.1652 26.7138V24.4115M24.9217 23.7913L6.20866 4.79996\" stroke=\"#E1E1E1\" stroke-width=\"2.5\" stroke-linecap=\"round\"/>\r\n</g>\r\n</g>\r\n<defs>\r\n<filter id=\"filter0_d_22941_19588\" x=\"1.2464\" y=\"0.873091\" width=\"27.1073\" height=\"31.338\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\r\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\r\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\r\n<feOffset dy=\"0.727273\"/>\r\n<feGaussianBlur stdDeviation=\"1.09091\"/>\r\n<feComposite in2=\"hardAlpha\" operator=\"out\"/>\r\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0\"/>\r\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_22941_19588\"/>\r\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_22941_19588\" result=\"shape\"/>\r\n</filter>\r\n<clipPath id=\"clip0_22941_19588\">\r\n<rect width=\"32\" height=\"32\" fill=\"white\"/>\r\n</clipPath>\r\n</defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/mute.ca9fd592520d274dcfdb3d248507a791.svg"),
        {
          React: SvgMute,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      